module.exports = "https://p.cds.unp.clasificados.pe/payment-success-education.1eb84070951e686626ac8b2231efb94a.png";